//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "SFAONS",
  data() {
    return {
      form: {
        facialExpression: "",
        spontaneousAction:"",
        postureAndFacialExpressions:"",
        EyeContact:"",
        emotionalResponse:"",
        lackOfFluctuation:"",
        emotionTotal:'',
        LackOfLanguageProficiency:"",
        LackOfLanguageContent:'',
        speechInterruption:'',
        delayedResponse:'',
        speakTotal:'',
        poorClothingAndPersonalHygiene:'',
        workOrStudyCannotLastLong:'',
        physicalImmobility:'',
        volitionTotal:'',
        ReducedInterestAndActivitiesInEntertainment:'',
        reducedSexualActivity:'',
        LackOfIntimacy:'',
        decreasedInterestInMakingFriends:'',
        interestTotal:'',
        notPayingAttentionToSocialInteraction:'',
        lackOfConcentrationDuringPsychologicalAssessment:'',
        attentionTotal:''
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "无" },
        { value: "1", name: "可疑" },
        { value: "2", name: "轻度" },
        { value: "3", name: "中度" },
        { value: "4", name: "重度" },
        { value: "5", name: "极重" },
      ],

    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/SFAONS.vue